const EXTRA_MINUTES = 10;
const MIN_TIME_LIMIT = 30;
const MAX_TIME_LIMIT = 60;

export const reminderSettings = {
  EXTRA_MINUTES,
  MIN_TIME_LIMIT,
  MAX_TIME_LIMIT,
};
